'use client';

import { forwardRef } from 'react';
import Link from 'next/link';
import { useTranslation } from '@weareconceptstudio/core';

const CustomLink = forwardRef(({ url, className = '', prefetch = true, scroll = true, replace = false, external = false, target, children, content, text, ariaLabel: ariaLabelProp, ...props }, ref) => {
	const { translate, selectedLang } = useTranslation();

	const href =
		typeof url === 'object'
			? {
					...url,
					pathname: external ? url.pathname : `/${selectedLang}${url.pathname}`,
			  }
			: external
			? url
			: `/${selectedLang}${url}`;

	const labelSource = text || ariaLabelProp || (typeof url === 'object' ? url.pathname : url);
	const ariaLabel = translate(labelSource?.replaceAll('/', '') || '');

	const translatedContent = content ? translate(content) : null;
	const linkContent = children || translatedContent;

	if (external) {
		return (
			<a
				ref={ref}
				href={href}
				className={`link-item ${className}`}
				rel='noopener noreferrer'
				target={target || '_blank'}
				aria-label={ariaLabel}
				{...props}
			>
				{linkContent}
			</a>
		);
	}

	return (
		<Link
			href={href}
			scroll={scroll}
			replace={replace}
			prefetch={prefetch}
			className={`link-item ${className}`}
			target={target || '_self'}
			aria-label={ariaLabel}
			{...props}
		>
			{linkContent}
		</Link>
	);
});

CustomLink.displayName = 'CustomLink';

export default CustomLink;
